/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseBaseInfo
 */
export interface ResponseBaseInfo {
    /**
     * 
     * @type {number}
     * @memberof ResponseBaseInfo
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseBaseInfo
     */
    name?: string;
}

/**
 * Check if a given object implements the ResponseBaseInfo interface.
 */
export function instanceOfResponseBaseInfo(value: object): value is ResponseBaseInfo {
    return true;
}

export function ResponseBaseInfoFromJSON(json: any): ResponseBaseInfo {
    return ResponseBaseInfoFromJSONTyped(json, false);
}

export function ResponseBaseInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBaseInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ResponseBaseInfoToJSON(json: any): ResponseBaseInfo {
    return ResponseBaseInfoToJSONTyped(json, false);
}

export function ResponseBaseInfoToJSONTyped(value?: ResponseBaseInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

